import { type GraphqlErrorCode } from '@/apollo/types/GraphqlErrorCode';
import { getGraphqlErrorExtensions } from '@/apollo/utils/getGraphqlErrorExtensions';

export const hasGraphqlErrorCode = (error: unknown, code: GraphqlErrorCode) =>
  getGraphqlErrorExtensions(error).some(
    (graphqlErrorExtensions) => graphqlErrorExtensions.code === code,
  );
